import React, { useState, useEffect } from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
//import { fetchData, putData, deleteData, FinishData, postData, updateData, DespatchData } from '../../apiService';
import {
  Card,
  CardContent,
  IconButton,
  Tooltip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { postData, fetchData, updateData, } from '../../../apiService';
//import Select from 'react-select'; // Import react-select
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import ArrowForward from '@mui/icons-material/ArrowForward';
import DeleteIcon from '@mui/icons-material/Delete';
import WrongLocationIcon from '@mui/icons-material/WrongLocation';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import TripOriginIcon from '@mui/icons-material/TripOrigin';
import DepartureBoardIcon from '@mui/icons-material/DepartureBoard';
import Modal from '@mui/material/Modal';
import { FaTimes } from 'react-icons/fa';
import Select from 'react-select';
import * as XLSX from 'xlsx';
import CircularProgress from '@mui/material/CircularProgress';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Button from '@mui/material/Button';
import SummarizeSharpIcon from '@mui/icons-material/SummarizeSharp';
import CloseIcon from '@mui/icons-material/Close';
//import { IconButton } from '@mui/material';
import AddCardTwoToneIcon from '@mui/icons-material/AddCardTwoTone';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'; // Importing the new icon
import CancelIcon from '@mui/icons-material/Cancel';
import DatePicker from 'react-datepicker';

const Delivery = () => {
  const { isAuthenticated, companyId, roleName, permissions, userId, token, logout, username } = useAuth();
  const hasCreateTransactionPermission = permissions && permissions.includes('Create Transaction');
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const { id } = useParams();
  const history = useHistory();
  const [Tripdata, setTripData] = useState([]);
  const [selectedTrip, setSelectedTrip] = useState(null);
  const [orderCutsomerdata, setOrderCutsomerData] = useState([]);
  const [startAutometereReading, setStartAutometereReading] = useState("");
  const [endAutometereReading, setEndAutometereReading] = useState("");
  const [isSubmit, setisSubmit] = useState(false);
  const [tripid, setTripId] = useState();
  const [customerId, setCustomerId] = useState();
  const [GetDat, setGetData] = useState();
  const [selectedDeliveryCustomer, setSelectedDeliveryCustomer] = useState(null);
  const [DeliveryData, setDeliveryData] = useState([]);
  const [DeliveryDatawithDisplay, setDeliveryDataDisplay] = useState([]);
  const [DTripId, setDeliveryTripId] = useState([]);
  const [showModalDeliveredShopRoute, setshowModalDeliveredShopRoute] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [TripClosingdata, setTripClosingData] = useState([]);
  const [OdoMeter, setOdometerReading] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  useEffect(() => {
    if (isAuthenticated && tokenIsExpired(token)) {
      logout();
      return;
    }

    if (isAuthenticated) {
      fetchTableData();
    }
  }, [isAuthenticated, companyId, roleName, username, userId, token, logout, id]);


  const fetchTableData = async () => {
    try {
      const response = await fetchData('TripApi', `/${companyId}`, token);
      if (response.responseCode === '1111') {
        setTripData(response.response_data);
        console.log(response);
      }
    } catch (error) {
      console.error('Error fetching Table Data', error);
    }
  };
  // Define necessary states
  const [note, setNote] = useState('');
  const [amount, setAmount] = useState('');
  const [itemList, setItemList] = useState([]);
  const [newItem, setNewItem] = useState({});
  const [selectedOption, setSelectedOption] = useState('');

  const [loading, setLoading] = useState(false);


  useEffect(() => {
    if (isAuthenticated && token) {
      fetchtableDataDelivery();
    }
  }, [isAuthenticated, token]);

  const fetchtableDataDelivery = async () => {
    try {
      setLoading(true); // start loader before fetch
      const response = await fetchData('DeliveryApi', `/${companyId}`, token);
      if (response.responseCode === '1111') {
        setDeliveryData(response.response_data);
        setDeliveryDataDisplay(response.response_data.customer); // check if needed
        setDeliveryTripId(response.response_data.id);
      }
    } catch (error) {
      console.error('Error fetching trip details:', error);
      if (error.response && error.response.status === 401) {
        logout();
      }
    } finally {  
      setLoading(false); // stop loader after fetch
    }
  };

  const handleDeliveryRouteClick = (trip) => {
    setSelectedDeliveryCustomer([]); // Clear the previous trip's customers

    setTimeout(() => {
      setSelectedDeliveryCustomer([...trip.customer]); // Set new trip's customers
    }, 0);
  };

  const handleDeliveryRouteClose = async (item) => {
    setSelectedItemId(item.id);
    try {
      const response = await fetchData('LoginApi', `/tmpType/${item.id}`, token);
      if (response.responseCode === '1111') {
        setTripClosingData(response.response_data);
        console.log(response);
      }
    } catch (error) {
      console.error('Error fetching Sale Details:', error);
    }
    setshowModalDeliveredShopRoute(true);
  };

  const closeDeliveredModal = () => {
    setshowModalDeliveredShopRoute(false);
  };

  const RouteclosingsubmitData = async (e) => {
    e.preventDefault();

    const CreateData = {
      Id: selectedItemId,
      EndAudometereReading: OdoMeter,
      TripClosedBy: userId,
      CompanyId: companyId,
    };

    const tripID = selectedItemId;

    try {
      await updateData('LoginApi', `${tripID}`, CreateData, token);
      console.log('trip Updated success:');
      setSuccessMessage("Trip Updated successfully!");
      //history.push('/Home');
      window.location.reload();
      setshowModalDeliveredShopRoute(false);
      setTimeout(() => {
        setSuccessMessage("");
      }, 3000);
    } catch (error) {
      console.error('Trip Updated error:', error);
      setIsLoading(false);
    }
  };
  const handleExpenseNameChange = (e) => {
    setNote(e.target.value);
  };

  const handleAmountChange = (e) => {
    setAmount(e.target.value);
  };

  const [ExpenseTypeOptions, setExpenseTypeOptions] = useState([]);
  const [selectedExpenseType, setSelectedExpenseType] = useState('');

  const fetchExpenseTypes = async () => {
    try {
      const response = await fetchData('OfficeExpenseApi', `/AccountHead/${companyId}`, token);
      if (response.responseCode === '1111') {
        const options = response.response_data.map(customer => ({
          value: customer.Id,
          label: customer.Description
        }));
        setExpenseTypeOptions(options);
      }
    } catch (error) {
      console.error('Error fetching Expense Types:', error);
    }
  };

  const [showOdometerReading, setShowOdometerReading] = useState(false);
  const handleExpenseTypeChange = (selectedOption) => {
    setSelectedExpenseType(selectedOption);
    setShowOdometerReading(selectedOption && selectedOption.label === 'Fuel');
  };

  useEffect(() => {
    fetchExpenseTypes();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSelectedExpenseType('');
    setNote('');
    setAmount('');
  };

  const AddtoListdata = (e) => {
    e.preventDefault();

    const updatedItem = { ...newItem };

    updatedItem.Note = note;
    updatedItem.Amount = amount;
    updatedItem.selectedExpenseType = selectedExpenseType.label;

    if (selectedExpenseType.label === 'Fuel') {
      updatedItem.OdoMeter = OdoMeter;
    }

    setItemList([...itemList, updatedItem]);

    setNewItem({
      ExpenseType: '',
      Note: '',
      Amount: 0,
      OdoMeter: '',
      ...(selectedOption === 'spare' && { ExpenseType: selectedExpenseType })
    });
    setSelectedExpenseType('');
    setNote('');
    setAmount('');
    setOdometerReading('');
  };

  const [selectedDate, setSelectedDate] = useState(new Date());
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [routeName, setRouteName] = useState('');



  const [selectedTripItemId, setSelectedTripItemId] = useState(null);
  const [TripExpensedata, setTripExpenseData] = useState([]);

  const openModal = async (tripdetails) => {
    // setSelectedTripItemId(tripdetails.id); // Store the selected trip details
    try {
      const response = await fetchData('CustomerReportAPI', `/tmpType/${tripdetails.id}`, token);
      if (response.responseCode === '1111') {
        setTripExpenseData(response.response_data);
        setSelectedTripItemId(response.response_data.Id);
        setRouteName(response.response_data.route);
        console.log(response);
      }
    } catch (error) {
      console.error('Error fetching Sale Details:', error);
    }
    setIsModalOpen(true);

  };

  const closeExModal = () => {
    setIsModalOpen(false);
  };

  const submitListData = async () => {
    try {
      if (itemList.length === 0) {
        return;
      }

      const ExpenseItems = itemList.map((item) => ({
        CompanyId: companyId,
        ExpenseType: item.selectedExpenseType,
        Note: item.Note,
        OdoMeter: item.OdoMeter || null,
        Amount: item.Amount,
      }));

      const ExpenseHead = {
        CompanyId: companyId,
        TripID: selectedTripItemId, // Ensure tripId is coming from the selected card
        //TripID: deliverytripid,
        EngineerID: userId,
        ExpenseEntryDate: selectedDate,
        CreatedBy: userId,
        CreatedDate: new Date(),
      };

      const CreatedData = {
        expense: ExpenseHead,
        expenseItem: ExpenseItems,
      };

      postData('ExpenseApi', CreatedData)
        .then((response) => {
          console.log('Data Created success:', response);

          setTimeout(() => { }, 3000);
          window.location.reload();
        })
        .catch((error) => {
          console.error('Data Create error:', error);
        });
    } catch (error) {
      console.error('Data Create error:', error);
    }
  };

  const handleExDelete = (index) => {
    const updatedList = [...itemList];
    updatedList.splice(index, 1);
    setItemList(updatedList);
  };


  return (
    <div className="flex flex-wrap justify-between">
      <Card className="w-full sm:w-3/4 mb-4 rounded-lg shadow-lg" style={{ backgroundColor: 'rgba(255, 255, 255, 0)' }}>
        <CardContent>
          <div>
            <h4 className="block uppercase text-lg font-semibold mb-4 linkcolor mr-2" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'darkred' }}>Delivery</h4>
          </div>

          {loading && (
            <div className="flex justify-center items-center h-40">
              <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-b-4 border-blue-500"></div>
            </div>
          )}
          {!loading && (
            <div className='w-full mb-5' style={{ display: 'flex', flexWrap: 'wrap' }}>
              {DeliveryData && DeliveryData.map((item) => (
                <Card key={item.id} className="customCard" style={{
                  marginBottom: '10px',
                  //backgroundColor: '#ADCE74',
                  backgroundColor: '#98D2C0',
                  color: 'white',
                  marginLeft: '30px',
                  height: '120px',
                  boxSizing: 'border-box',
                  '@media (min-width: 600px)': {
                    width: 'calc(20% - 20px)'
                  }
                }} onClick={() => handleDeliveryRouteClick(item)}>
                  <CardContent style={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    alignItems: 'left',
                    padding: '10px',
                    boxSizing: 'border-box'
                  }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                      <div>
                        <div style={{
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          fontSize: '14px',
                          fontWeight: 'bold',
                          textAlign: 'left'
                        }}>
                          {item.route}
                        </div>
                        <div style={{
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          fontSize: '12px',
                          fontWeight: 'bold',
                          textAlign: 'left'
                        }}>
                          {item.description}
                        </div>
                        <div style={{
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          fontSize: '12px',
                          fontWeight: 'bold',
                          textAlign: 'left'
                        }}>
                          Trip No: {item.tripNo}
                        </div>
                      </div>

                      <div style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        fontSize: '14px',
                        fontWeight: 'bold',
                        textAlign: 'right'
                      }}>

                        <Tooltip title="Route Expense">
                          <IconButton aria-label="add" onClick={(e) => { e.stopPropagation(); openModal(item); }}>
                            <AddCardTwoToneIcon style={{ color: 'darkred' }} />
                          </IconButton>
                        </Tooltip>
                      </div>

                    </div>
                    <Tooltip title="Route Closing">
                      <IconButton aria-label="close" onClick={(e) => { e.stopPropagation(); handleDeliveryRouteClose(item); }}>
                        <CloseIcon style={{ color: 'white' }} />
                      </IconButton>
                    </Tooltip>
                  </CardContent>
                </Card>

              ))}
            </div>
          )}
        </CardContent>
      </Card>

      <Modal open={showModalDeliveredShopRoute} onClose={closeDeliveredModal} className={showModalDeliveredShopRoute ? 'notification-modal' : ''}>
        <div className="fixed inset-0 flex items-start justify-center z-10" style={{ marginTop: '100px' }}>
          <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '700px', maxHeight: '80vh', overflowY: 'auto', overflowX: 'auto' }}>
            <div className="flex justify-end mt-2">
              <Tooltip title="SAVE">
                <Button onClick={RouteclosingsubmitData} style={{ color: 'whitesmoke', fontWeight: 'bolder', marginLeft: '-2px', backgroundColor: 'darkgreen' }} disabled={isLoading}>
                  {isLoading ? <CircularProgress size={24} color="inherit" /> : "Update"} <CheckCircleIcon />
                </Button>
              </Tooltip>
              <Tooltip title="SAVE">
                <Button onClick={closeDeliveredModal} style={{ color: 'whitesmoke', fontWeight: 'bolder', marginLeft: '2px', backgroundColor: 'orangered' }} disabled={isLoading}>
                  Close
                </Button>
              </Tooltip>
              <div>

              </div>

            </div>

            <h4 style={{ fontFamily: 'Times New Roman', textAlign: 'center', color: 'black', fontWeight: 'bolder' }}>Trip Closing</h4>

            <div className="w-full mb-4 flex">
              <div className="w-1/2 mr-2">
                <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="Salesman">
                  Salesman
                </label>
                <input
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                  name="Salesman"
                  value={TripClosingdata.Salesman}
                  type="text"
                  disabled
                />
              </div>

              <div className="w-1/2 mr-2">
                <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="Driver">
                  Driver
                </label>
                <input
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                  name="Driver"
                  value={TripClosingdata.Driver}
                  type="text"
                  disabled
                />
              </div>

              <div className="w-1/2 mr-2">
                <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="Vehicle">
                  Vehicle
                </label>
                <input
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                  name="Vehicle"
                  value={TripClosingdata.vehicle}
                  type="text"
                  disabled
                />
              </div>
            </div>

            <div className="w-full mb-4 flex">
              <div className="w-1/2 mr-2">
                <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="Vehicle">
                  Route
                </label>
                <input
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-black leading-tight focus:text-black focus:shadow-outline"
                  name="Vehicle"
                  value={TripClosingdata.Description}
                  type="text"
                  disabled
                />
              </div>
              <div className="w-1/2 mr-2">
                <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="StartOdometer">
                  End Odometer
                </label>
                <input
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-black leading-tight focus:text-black focus:shadow-outline"
                  name="EndOdometer"
                  value={OdoMeter}
                  onChange={(e) => setOdometerReading(e.target.value)}
                  type="text"
                  placeholder="Enter End Odometer"
                />
              </div>
            </div>
          </div>
        </div>
      </Modal>

      {selectedDeliveryCustomer && (
        <Card className="w-full sm:w-1/5 mb-4 rounded-lg shadow-lg" style={{ backgroundColor: 'rgba(255, 255, 255, 0)' }}>
          <CardContent>
            <div>
              <h6 className="block uppercase text-lg font-semibold mb-4 linkcolor mr-2" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'brown', fontSize: '15px' }}>Customer's</h6>
            </div>
            <div className='w-full mb-5' style={{ display: 'flex', flexWrap: 'wrap' }}>
              {selectedDeliveryCustomer.map((customer) => (
                <Card key={customer.id} className="customCard" style={{
                  marginBottom: '10px',
                  backgroundColor: customer.balance === customer.billAmount
                    ? '#E69DB8'
                    : customer.balance > 0
                      ? 'red'
                      : 'green',
                  color: 'white',
                  fontSize: '11px',
                }}>
                  <CardContent style={{ height: '50px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ height: '50px', width: '550px', padding: '10px' }}>  {customer.name}</div>
                    <Link to={`/Despatch/${customer.id}`}>
                      <Tooltip title="Create Despatch">
                        <IconButton style={{ height: '40px' }}>
                          <ArrowForward style={{ color: 'whitesmoke' }} />
                        </IconButton>
                      </Tooltip>
                    </Link>
                  </CardContent>
                </Card>
              ))}
            </div>
          </CardContent>
        </Card>
      )}



      <Modal open={isModalOpen} className={isModalOpen ? 'notification-modal' : ''}>

        <div className="fixed inset-0 flex items-start justify-center z-10" style={{ marginTop: '100px' }}>

          <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '700px', maxHeight: '80vh', overflowY: 'auto', overflowX: 'auto' }}>
            <div className="button-container-2">

              <Tooltip title="Submit">
                <Button onClick={submitListData} style={{ color: 'green', fontWeight: 'bolder' }} disabled={isLoading}>
                  {isLoading ? <CircularProgress size={24} color="inherit" /> : "Submit"} <CheckCircleIcon />
                </Button>
              </Tooltip>
            </div>
            <h4 style={{ textAlign: 'center', fontFamily: 'Times New Roman', fontWeight: 'bolder', color: 'darkred' }}>Add Expense</h4>
            <h6 style={{ textAlign: 'center', fontFamily: 'Times New Roman', fontWeight: 'bolder', color: 'darkmagenta' }}>{routeName}</h6>

            <div className="w-full mb-4" style={{ textAlign: 'center' }}>
              <label className="block tracking-wide text-white text-base font-bold mb-2" htmlFor="description">

              </label>
            </div>
            <div className="bg-tabcolor-100 rounded-lg shadow-lg p-6">
              <div className="w-full mb-4 flex">

                <div className="w-1/7 mr-3" style={{ marginTop: '-20px' }}>
                  <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="packingDate" style={{ fontSize: '16px' }}>
                    Date
                  </label>
                  <DatePicker
                    selected={selectedDate}
                    onChange={date => setSelectedDate(date)}
                    dateFormat="dd/MM/yyyy"
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    readOnly
                  />
                </div>

                <div className="w-1/7 mr-3" style={{ width: '275px', marginTop: '-20px' }}>
                  <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="packingDate" style={{ fontSize: '16px' }}>
                    Expense
                  </label>
                  <Select
                    value={selectedExpenseType}
                    onChange={handleExpenseTypeChange}
                    options={ExpenseTypeOptions}
                    placeholder="--Expense--"
                    isSearchable
                  />
                </div>

              </div>
              <div className="w-full mb-4 flex">
                <div className="w-1/7 mr-3" style={{ width: '400px', marginTop: '-22px' }}>
                  <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="packingSlipNumber" style={{ fontSize: '16px' }}>
                    Note
                  </label>
                  <textarea
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                    placeholder="Enter Notes"
                    rows={3}
                    maxLength={250}
                  />
                </div>
              </div>
              <div className="w-full mb-4 flex">
                {showOdometerReading && (
                  <div className="w-1/7 mr-3" style={{ marginTop: '-20px', width: '150px' }}>
                    <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="OdoMeter" style={{ fontSize: '16px' }}>
                      Odometer Reading
                    </label>
                    <input
                      type="text"
                      id="OdoMeter"
                      name="OdoMeter"
                      value={OdoMeter}
                      onChange={(e) => setOdometerReading(e.target.value)}
                      placeholder="Enter Odometer Reading"
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    />
                  </div>
                )}
                <div className="w-full md:w-1/2 pr-2" style={{ marginTop: '-20px', width: '150px' }}>
                  <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="AddressLine1">
                    Amount
                  </label>
                  <input
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    value={amount}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*\.?\d*$/.test(value)) {
                        setAmount(value);
                      }
                    }}
                    pattern="^\d*\.?\d*$"
                    maxLength={5}
                  />
                </div>
              </div>
              <br />
              <div className="w-full mb-4 flex">
                <Tooltip title="Add">
                  <Button onClick={AddtoListdata} style={{ marginTop: '-30px', color: 'green', cursor: 'pointer' }}>
                    ADD <CheckCircleIcon />
                  </Button>
                </Tooltip>
                <Tooltip title="Cancel">
                  <Button onClick={closeExModal} style={{ marginTop: '-30px', color: 'red', border: 'none', background: 'none', cursor: 'pointer' }}>
                    Cancel<CancelIcon />
                  </Button>
                </Tooltip>
              </div>
              {itemList.length > 0 && (
                <div className="overflow-auto" style={{ overflowY: 'auto' }}>
                  <table className="w-full border-collapse border" style={{ overflowY: 'auto' }}>
                    <thead>
                      <tr className="bg-gray-200 border-b">
                        <th className="px-4 py-2 text-left border-r" style={{ width: '5px' }}>Sl.no</th>
                        <th className="px-4 py-2 text-left border-r" style={{ width: '500px' }}>Expense</th>
                        <th className="px-4 py-2 text-left border-r" style={{ width: '500px' }}>Note</th>
                        <th className="px-4 py-2 text-left border-r" style={{ width: '75px' }}>Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {itemList.map((item, index) => (
                        <tr key={index} className={index % 2 === 0 ? 'bg-gray-100' : 'bg-white'}>
                          <td className="px-4 py-2 border-r" style={{ width: '5px' }}>{index + 1}</td>
                          <td className="px-4 py-2 border-r" style={{ width: '500px' }}>{item.selectedExpenseType}</td>
                          <td className="px-4 py-2 border-r" style={{ width: '500px' }}>{item.Note}</td>
                          <td className="px-4 py-2 border-r" style={{ width: '75px', textAlign: 'right', cursor: 'pointer' }}
                            onClick={() => handleExDelete(index)}>{item.Amount}
                            <Tooltip title="Delete"><DeleteIcon style={{ color: 'brown' }} /></Tooltip></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </Modal>
    </div>

  );
};

export default Delivery;
